import '/src/tailwind.css';


document.addEventListener('DOMContentLoaded', function () {
    if (!sessionStorage.getItem('session_id')) {
        sessionStorage.setItem('session_id', 'session_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now());
    }

    let sessionId = sessionStorage.getItem('session_id');

    if (!sessionStorage.getItem('referrer')) {
        sessionStorage.setItem('referrer', document.referrer);
    }

    let trackingRef = sessionStorage.getItem('referrer') || 'direct';

   
    window.addEventListener('mousemove', loadResources, { once: true });
    window.addEventListener('touchstart', loadResources, { once: true });
    window.addEventListener('scroll', loadResources, { once: true });


    function loadResources() {
        const gtagScript1 = document.createElement('script');
        gtagScript1.src = 'https://www.googletagmanager.com/gtag/js?id=G-E5LGRGZEZP';
        gtagScript1.async = true;
        document.body.appendChild(gtagScript1);

        const gtagScript2 = document.createElement('script');
        gtagScript2.src = 'https://www.googletagmanager.com/gtag/js?id=AW-11171007225';
        gtagScript2.async = true;
        document.body.appendChild(gtagScript2);

        gtagScript1.onload = function() {
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag('js', new Date());
            gtag('config', 'G-E5LGRGZEZP');
        };

        gtagScript2.onload = function() {
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag('js', new Date());
            gtag('config', 'AW-11171007225');
        };

        (function (h, o, t, j, a, r) {
            h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
            h._hjSettings = { hjid: 5010227, hjsv: 6 };
            a = o.getElementsByTagName('head')[0];
            r = o.createElement('script');
            r.async = 1;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    }
});
